import { generateErrors, generateErrorsExtraDoc, generateVatPartnersUpdateErrors } from 'utilities/util';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { TYPES } from 'action-types/booking';
import { TYPES as PARTNERS } from 'action-types/partners';
import { TYPES as VENDORS } from 'action-types/vendors';
import { TYPES as MASTER } from 'action-types/materialMaster';
import { TYPES as FILTER_TYPES } from 'action-types/filters';
import { callApiV3Get, callApiV3Put, callApiV3Post, callApiV3Delete, callApiV2Put, callApiV2Post } from 'utilities/apiCaller';
import API from 'constants/api';
import CostColumnsData from 'views/job-costing/utils/CostColumnsData';
import { IStore } from 'reducers/index';
import { TransportMode } from 'constants/modes';
import { SUCCESS_MESSAGE } from 'constants/messages';
import { remapExportCostAndRevenueData, remapImportCostAndRevenueData, remapCostAndRevenueData } from 'utilities/nftp';

export const fetchCostAndRevenue = (
    type: number,
    valueId: number[],
    targetType = 'origin',
) => {
    const params = { SearchId: valueId, Level: type };
    if (targetType === 'destination') {
        return async (dispatch: ThunkDispatch<any, any, Action>) => {
            dispatch({ type: TYPES.FETCH_COST_REVENUE.PENDING });
            try {
                const res = await callApiV3Post(
                    `${API.CostRevenue.GetETSCostRev}`,
                    params,
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    },
                );
                const remappedData = remapImportCostAndRevenueData(res.data);
                dispatch({
                    type: TYPES.FETCH_COST_REVENUE
                        .FULFILLED,
                    response: remappedData,
                });
            } catch (e) {
                const errors = generateErrors(e);
                dispatch({
                    type: TYPES.FETCH_COST_REVENUE.REJECTED,
                    errors,
                });
            }
        };
    } else {
        return async (dispatch: ThunkDispatch<any, any, Action>) => {
            dispatch({ type: TYPES.FETCH_COST_REVENUE.PENDING });
            try {
                const res = await callApiV3Post(
                    API.CostRevenue.GetCostAndRevenue,
                    params,
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    },
                );
                const remappedData = remapExportCostAndRevenueData(res.data);
                dispatch({
                    type: TYPES.FETCH_COST_REVENUE
                        .FULFILLED,
                    response: remappedData,
                });
            } catch (e) {
                const errors = generateErrors(e);
                dispatch({
                    type: TYPES.FETCH_COST_REVENUE.REJECTED,
                    errors,
                });
            }
        };
    }
};

export const addCostAndRevenue = (data: any, targetType = 'origin', vatPartnersData?: any) => {
    const url = API.CostRevenue.AddCostAndRevenue;
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.ADD_COST_REVENUE.PENDING });
        try {
            const res = await callApiV3Post(
                url,
                { ...data },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            if (res && vatPartnersData && vatPartnersData.vatPartners.length > 0) {
                const apiUrl = targetType === 'origin' ? API.VatPartners.updateVatPartnersEsso : API.VatPartners.updateVatPartnersIsso;
                try {
                    const vatUpdateResult = await callApiV2Put(apiUrl, vatPartnersData, {});
                    if (vatUpdateResult.status === 200 && vatUpdateResult.data.length > 0) {
                        const errors = generateVatPartnersUpdateErrors(vatUpdateResult.data);
                        dispatch({
                            type: TYPES.ADD_COST_REVENUE.REJECTED,
                            errors,
                        });
                    } else {
                        dispatch({
                            type: TYPES.ADD_COST_REVENUE.FULFILLED,
                            newCode: res.status === 200 && JSON.stringify(res.data) === '{}' ? SUCCESS_MESSAGE : res.data,
                        });
                    }
                } catch (e) {
                    const errors = generateVatPartnersUpdateErrors(e);
                    dispatch({
                        type: TYPES.ADD_COST_REVENUE.REJECTED,
                        errors,
                    });
                }
            } else {
                dispatch({
                    type: TYPES.ADD_COST_REVENUE.FULFILLED,
                    newCode: res.status === 200 && JSON.stringify(res.data) === '{}' ? SUCCESS_MESSAGE : res.data,
                });
            }
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.ADD_COST_REVENUE.REJECTED,
                errors,
            });
        }
    };
};

export const resetAddCostAndRevenue = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.ADD_COST_REVENUE.RESET_ERROR });
    };
};
/*
    DocumentStages  
        Bookings = 1,
        FCR = 2,
        ETS = 3
    RateRequestAction
        Create = 1,
        Change = 2,
        Cancel = 3,
        CreateRemoved = 4,
        ChangeRemoved = 5,
        AdHocRate = 6,
        StandardRate = 7,
        Update = 8,
        InvoiceCreate=9,
        InoiceUpdate=10
 */
export const updateCharges = (
    ReferenceId: number,
    DocumentStage: number,
    RateRequestAction: number,
    Category: 'ESSO' | 'ISSO' = 'ESSO',
) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        const UserId = getState().nickname.userNickName
            ? getState().nickname.userNickName.employeeId
            : '';
        dispatch({ type: TYPES.UPDATE_CHARGES.PENDING });
        try {
            const res = await callApiV3Post(
                `${API.CostRevenue.UpdateCharges}`,
                {
                    Filter: [
                        {
                            ReferenceId,
                            DocumentStage,
                            RateRequestAction,
                            Category,
                            UserId,
                        },
                    ],
                },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.UPDATE_CHARGES.FULFILLED,
                update: res.data,
            });
        } catch (e) {
            const errors =
                e &&
                    e.response &&
                    e.response.data &&
                    e.response.data.errors &&
                    e.response.data.errors.length
                    ? generateErrors(e)
                    : generateErrorsExtraDoc(e);
            dispatch({
                type: TYPES.UPDATE_CHARGES.REJECTED,
                errors,
            });
        }
    };
};

export const refreshAthenaRates = (
    ReferenceId: number,
    DocumentId: number,
    DocumentStage: number,
    RateRequestAction: number,
    Category: 'ESSO' | 'ISSO' = 'ESSO',
) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        const UserId = getState().nickname.userNickName
            ? getState().nickname.userNickName.employeeId
            : '';
        dispatch({ type: TYPES.REFRESH_ATHENA_RATES.PENDING });
        try {
            const res = await callApiV3Post(
                `${API.CostRevenue.RefreshAthenaRates}`,
                {
                    Filter: [
                        {
                            ReferenceId,
                            DocumentId,
                            DocumentStage,
                            RateRequestAction,
                            Category,
                            UserId,
                        },
                    ],
                },
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.REFRESH_ATHENA_RATES.FULFILLED,
                update: res.data,
            });
        } catch (e) {
            const errors = e?.response?.data?.errors?.length
                ? generateErrors(e)
                : generateErrorsExtraDoc(e);
            dispatch({
                type: TYPES.REFRESH_ATHENA_RATES.REJECTED,
                errors,
            });
        }
    };
};

export const resetParties = () => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: PARTNERS.RESET_PARTNERS.PENDING });
        dispatch({ type: VENDORS.RESET_VENDORS.PENDING });
        dispatch({ type: MASTER.RESET_CUSTOMER_DATA.PENDING });
    };
};

export const fetchDistributionData = (valueId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_DISTRIBUTION_DATA.PENDING });
        try {
            const res = await callApiV3Get(
                `${API.CostRevenueNew.GetDistributionData(
                    valueId,
                )}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.FETCH_DISTRIBUTION_DATA.FULFILLED,
                distributionData: res.data,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_DISTRIBUTION_DATA.REJECTED,
                errors,
            });
        }
    };
};

export const fetchJobStatus = (valueId: number) => {
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.VALIDATE_JOB_STATUS.PENDING });
        try {
            const res = await callApiV3Get(
                `${API.CostRevenueNew.getJobStatus(valueId)}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.VALIDATE_JOB_STATUS.FULFILLED,
                validateJobStatus: res.data.validateJobStatus,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.VALIDATE_JOB_STATUS.REJECTED,
                errors,
            });
        }
    };
};
const initialState = {
    totalCount: 0,
    page: 1,
    pageSize: 10,
    data: [],
};
export const fetchRevenueData = (
    id: number,
    page?: number,
    pageSize?: number,
) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        dispatch({ type: TYPES.FETCH_REVENUE_DATA.PENDING });
        try {
            const sorting = getState().filters.column
                ? {
                    order: getState().filters.order,
                    column: getState().filters
                        .column,
                }
                : {
                    order: 0,
                    column: 'id',
                };
            const pageNo = getState().filters.page;
            const res = await callApiV3Get(
                `${API.CostRevenueNew.getCostRevenueData}/${id}/revenue?page=${pageNo}&pageSize=${pageSize}&column=${sorting.column}&order=${sorting.order}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            const remappedData = remapCostAndRevenueData(res.data);
            dispatch({
                type: FILTER_TYPES.SET_TOTAL_COUNT,
                totalCount: res.data.totalCount,
            });
            dispatch({
                type: TYPES.FETCH_REVENUE_DATA.FULFILLED,
                revenueResponse:
                    res.status !== 200
                        ? initialState
                        : remappedData,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_REVENUE_DATA.REJECTED,
                errors,
            });
        }
    };
};

export const fetchCostData = (id: number, page?: number, pageSize?: number) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        dispatch({ type: TYPES.FETCH_COST_DATA.PENDING });
        try {
            const sorting = getState().filters.column
                ? {
                    order: getState().filters.order,
                    column: getState().filters
                        .column,
                }
                : {
                    order: 0,
                    column: 'id',
                };
            const pageNo = getState().filters.page;
            const res = await callApiV3Get(
                `${API.CostRevenueNew.getCostRevenueData}/${id}/cost?page=${pageNo}&pageSize=${pageSize}&column=${sorting.column}&order=${sorting.order}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            const remappedData = remapCostAndRevenueData(res.data);
            dispatch({
                type: FILTER_TYPES.SET_TOTAL_COUNT,
                totalCount: res.data.totalCount,
            });
            dispatch({
                type: TYPES.FETCH_COST_DATA.FULFILLED,
                costResponse:
                    res.status !== 200
                        ? initialState
                        : remappedData,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_COST_DATA.REJECTED,
                errors,
            });
        }
    };
};

export const saveCostAndRevenue = (
    data: any,
    targetType = 'origin',
    type: string,
    isEdit?: boolean,
) => {
    let url = API.CostRevenueNew.saveRevenueData;
    if (type === CostColumnsData.TYPES.COST) {
        url = API.CostRevenueNew.saveCostData;
    }
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.ADD_COST_REVENUE.PENDING });
        try {
            let res = { data: null, status: 0 };
            if (isEdit) {
                res = await callApiV3Put(
                    url,
                    { ...data },
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    },
                );
            } else {
                res = await callApiV3Post(
                    url,
                    { ...data },
                    {
                        headers: {
                            TransportMode:
                                TransportMode.Ocean,
                        },
                    },
                );
            }
            if (res.status >= 200 && res.status < 300) {
                dispatch({
                    type: TYPES.ADD_COST_REVENUE.FULFILLED,
                    newCode: SUCCESS_MESSAGE,
                });
            }
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.ADD_COST_REVENUE.REJECTED,
                errors,
            });
        }
    };
};

export const fetchExportJobsChargeRev = (
    id: number,
    viewType?: number,
    pageSize?: number,
) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        dispatch({ type: TYPES.FETCH_EXPORTJOBS_CHARGE_REV.PENDING });
        try {
            const sorting = getState().filters.column
                ? {
                    order: getState().filters.order,
                    column: getState().filters
                        .column,
                }
                : {
                    order: 0,
                    column: 'id',
                };
            const pageNo = getState().filters.exportPage;
            const res = await callApiV3Get(
                `${API.CostRevenueNew.getExportJobsCharge}/revenue/${id}/export-jobs-charges?viewType=${viewType}&page=${pageNo}&pageSize=${pageSize}&column=${sorting.column}&order=${sorting.order}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.FETCH_EXPORTJOBS_CHARGE_REV
                    .FULFILLED,
                exportJobsChargeRev: res.data,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_EXPORTJOBS_CHARGE_REV
                    .REJECTED,
                errors,
            });
        }
    };
};

export const fetchExportJobsChargeCost = (
    id: number,
    viewType?: number,
    pageSize?: number,
) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        dispatch({ type: TYPES.FETCH_EXPORTJOBS_CHARGE_COST.PENDING });
        try {
            const sorting = getState().filters.column
                ? {
                    order: getState().filters.order,
                    column: getState().filters
                        .column,
                }
                : {
                    order: 0,
                    column: 'id',
                };
            const pageNo = getState().filters.exportPage;
            const res = await callApiV3Get(
                `${API.CostRevenueNew.getExportJobsCharge}/cost/${id}/export-jobs-charges?viewType=${viewType}&page=${pageNo}&pageSize=${pageSize}&column=${sorting.column}&order=${sorting.order}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.FETCH_EXPORTJOBS_CHARGE_COST
                    .FULFILLED,
                exportJobsChargeCost: res.data,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_EXPORTJOBS_CHARGE_COST
                    .REJECTED,
                errors,
            });
        }
    };
};

export const fetchEquipmentsExportJob = (
    id: number,
    exportJobId: number,
    essoRateDetailId: number,
    page?: number,
    pageSize?: number,
) => {
    return async (
        dispatch: ThunkDispatch<any, any, Action>,
        getState: () => IStore,
    ) => {
        dispatch({ type: TYPES.FETCH_EQUIPMENTS_EXPORTJOB.PENDING });
        try {
            const sorting = getState().filters.column
                ? {
                    order: getState().filters.order,
                    column: getState().filters
                        .column,
                }
                : {
                    order: 0,
                    column: 'id',
                };
            const pageNo = getState().filters.equipmentPage;
            const res = await callApiV3Get(
                `${API.CostRevenueNew.getEquipmentDetails}/${id}/esso-export-job-details?exportJobId=${exportJobId}&essoRateDetailId=${essoRateDetailId}&page=${pageNo}&pageSize=${pageSize}&column=${sorting.column}&order=${sorting.order}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.FETCH_EQUIPMENTS_EXPORTJOB
                    .FULFILLED,
                equipmentsForExportJob: res.data,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_EQUIPMENTS_EXPORTJOB.REJECTED,
                errors,
            });
        }
    };
};

export const fetchCBLEditStatus = (
    id: number,
    chargeItems: any,
    type: string,
) => {
    const params = {
        cblId: id,
        chargeItemsWithView: chargeItems,
        itemType: type,
    };
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.VALIDATE_CBL_EDIT_STATUS.PENDING });
        try {
            const res = await callApiV3Post(
                `${API.CostRevenueNew.getCBLEditStatus}`,
                params,
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.VALIDATE_CBL_EDIT_STATUS.FULFILLED,
                editChargeItemStatus: res.data,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.VALIDATE_CBL_EDIT_STATUS.REJECTED,
                errors,
            });
        }
    };
};

export const fetchChargeItemEdit = (chargeItems: number[], type: string) => {
    let url = '';
    if (type === 'REV') {
        url = API.CostRevenueNew.getRevChargeItemEdit;
    } else {
        url = API.CostRevenueNew.getCostChargeItemEdit;
    }
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.GET_CHARGE_ITEM_DETAILS_EDIT.PENDING });
        try {
            const res = await callApiV3Get(
                `${url}?${chargeItems
                    .map((n) => 'ids=' + n)
                    .join('&')}`,
                {},
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.GET_CHARGE_ITEM_DETAILS_EDIT
                    .FULFILLED,
                chargeItemData: res.data,
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.GET_CHARGE_ITEM_DETAILS_EDIT
                    .REJECTED,
                errors,
            });
        }
    };
};

export const deleteChargeItemCBL = (
    params: any,
    type: string,
    costAndRevenueId: number,
) => {
    let url = '';
    type === 'REV'
        ? (url = API.CostRevenueNew.getRevChargeItemDelete)
        : (url = API.CostRevenueNew.getCostChargeItemDelete);
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.DELETE_CHARGE_ITEMS_CBL.PENDING });
        try {
            const res = await callApiV3Delete(`${url}`, params, {
                headers: { TransportMode: TransportMode.Ocean },
            });
            dispatch({
                type: TYPES.DELETE_CHARGE_ITEMS_CBL.FULFILLED,
                chargeItemDeleteStatus: res.status,
            });
            if (res.status === 204) {
                type === 'REV'
                    ? dispatch(
                        fetchRevenueData(
                            Number(
                                costAndRevenueId,
                            ),
                            1,
                            10,
                        ),
                    )
                    : dispatch(
                        fetchCostData(
                            Number(
                                costAndRevenueId,
                            ),
                            1,
                            10,
                        ),
                    );
            }
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.DELETE_CHARGE_ITEMS_CBL.REJECTED,
                errors,
            });
        }
    };
};

export const fetchPendingProcessMessages = (
    JobId: number,
    JobType: 'Export' | 'Import',
) => {
    const params = { JobId, JobType};
    return async (dispatch: ThunkDispatch<any, any, Action>) => {
        dispatch({ type: TYPES.FETCH_PENDING_PROCESSING_MESSAGES.PENDING });
        try {
            const res = await callApiV2Post(
                `${API.PendingProcessingMessages.GetPendingProcessingMessages}`,
                params,
                {
                    headers: {
                        TransportMode:
                            TransportMode.Ocean,
                    },
                },
            );
            dispatch({
                type: TYPES.FETCH_PENDING_PROCESSING_MESSAGES.FULFILLED,
                payload: {type: JobType, messages: res.data?.messages || []},
            });
        } catch (e) {
            const errors = generateErrors(e);
            dispatch({
                type: TYPES.FETCH_PENDING_PROCESSING_MESSAGES.FULFILLED,
                payload: errors,
            });
        }
    };
};